/* global splitkonNews */

/**
 * splitkonNews is coming from function.php,
 *      => function splitkon_frontend_scripts
 *          => wp_localize_script( 'splitkon-view-news-archive' ... )
 */
if ( 0 < splitkonNews.shown ) {
    splitkonNews.shown = +splitkonNews.shown ?? 0;

    function printNewsCount( spanShownCount ) {
        spanShownCount.innerHTML = splitkonNews.shown;
        document.querySelector( '.splitkon-home-page__news-count-overall' ).innerHTML = splitkonNews['total_posts_count'] ?? 0;
        document.querySelectorAll( '.splitkon-home-page__news-count-on-page' )?.forEach( ( spanNewsCountOnPage ) => {
            spanNewsCountOnPage.innerHTML = splitkonNews['found_posts'];
        } );
    }

    function onClickLoadMoreButton( event, newsContainer, spanShownCount ) {
        event.preventDefault();
        event.target.classList.add( 'wp-element-button--disabled' );

        splitkonNews['current_page']++;
        let request = new XMLHttpRequest();
        request.onreadystatechange = () => {
            if ( request.readyState === 4 ) {
                if ( request.status === 200 ) {
                    const response = JSON.parse( request.response );

                    splitkonNews.shown += response.data.count ?? 0;

                    spanShownCount.innerHTML = splitkonNews.shown;
                    newsContainer.innerHTML += response.data.results ?? '';
                }

                event.target.classList.remove( 'wp-element-button--disabled' );
                if ( splitkonNews['current_page'] >= splitkonNews['max_page'] ) {
                    event.target.classList.add( 'wp-element-button--hidden' );
                }
            }
        };

        request.open( 'GET', `${splitkonNews['ajax_url']}?action=splitkon_load_more_news&query_args=${ splitkonNews['main_query'] }&page_to_load=${ splitkonNews['current_page'] }`, true );
        request.send();
    }

    document.addEventListener( 'DOMContentLoaded', () => {
        const loadMoreButton = document.querySelector( '.splitkon-home-page__load-more-button a' );
        const newsContainer = document.querySelector( '.splitkon-news .wp-block-post-template' );
        const spanShownCount = document.querySelector( '.splitkon-home-page__news-count-shown' );

        if ( splitkonNews['current_page'] >= splitkonNews['max_page'] ) {
            loadMoreButton.classList.add( 'wp-element-button--hidden' );
        } else {
            loadMoreButton.addEventListener( 'click', ( event ) => onClickLoadMoreButton( event, newsContainer, spanShownCount ) );
        }

        printNewsCount( spanShownCount );
    } )
}
